module.exports = __webpack_public_path__ + "img/40_69_004_830.0609f890.jpg";